export const FAST_X_MOVIE_DETAIL = {
  id: 'fast-x-demo',
  stream_id: 'fast-x-demo',
  name: 'Hızlı ve Öfkeli 10',
  title: 'Hızlı ve Öfkeli 10',
  originalTitle: 'Fast X',
  year: '2023',
  rating: '5.7',
  yorum_sayisi: 2,
  genre: 'Aksiyon',
  genres: ['Aksiyon', 'Suç', 'Gerilim', 'Macera'],
  runtime: '2 sa 22 dk',
  certification: '13+',
  tagline: 'Yolun sonu başlıyor.',
  director: 'Louis Leterrier',
  cast: ['Vin Diesel', 'Michelle Rodriguez', 'Jason Momoa', 'Tyrese Gibson', 'Ludacris'],
  overview: 'Dom Toretto ve ailesi, geçmişin gölgelerinden gelen ve kanlı bir intikamla beslenen Dante ile karşı karşıya gelir. Dom, sevdiği herkesi korumak için şimdiye kadarki en ölümcül rakibine karşı mücadele etmek zorundadır.',
  description: 'Dom Toretto ve ailesi, geçmişin gölgelerinden gelen ve kanlı bir intikamla beslenen Dante ile karşı karşıya gelir. Dom, sevdiği herkesi korumak için şimdiye kadarki en ölümcül rakibine karşı mücadele etmek zorundadır.',
  poster: 'https://image.tmdb.org/t/p/w500/fiVW06jE7z9YnO4trhaMEdclSiC.jpg',
  stream_icon: 'https://image.tmdb.org/t/p/w500/fiVW06jE7z9YnO4trhaMEdclSiC.jpg',
  backdrop: 'https://image.tmdb.org/t/p/original/4XM8DUTQb3lhLemJC51Jx4a2EuA.jpg',
  backdropUrl: 'https://image.tmdb.org/t/p/original/4XM8DUTQb3lhLemJC51Jx4a2EuA.jpg',
};
